"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import Image from "next/image";
export function SiteFooter() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Link href="/" aria-label="Home" className="inline-flex items-center justify-center bg-center bg-no-repeat sm:w-[80px] sm:h-[40px] hover:opacity-80 transition-opacity opacity-50 mix-blend-screen w-[60px] h-[32px] bg-[url(/drawables/mvplayer_logo_tiny.png)] bg-contain rounded grayscale" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">{t0}<p className="sm:text-sm sm:text-left text-xs font-medium text-[#8E9285] font-geist text-center">©<span className="font-geist" id="y">{new Date().getFullYear()}</span>{" "}MVPlayer.eu - You play, We score!</p></div>;
    t2 = <Link href="/privacy" className="text-xs font-medium text-[#8E9285] font-geist hover:text-white transition-colors sm:order-none order-first sm:mb-0 mb-4">Privacy Policy</Link>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <a href="https://chat.whatsapp.com/LD3KVM5QYId6p60tPdznDl" target="_blank" rel="noopener noreferrer" className="inline-flex gap-2 sm:px-4 sm:py-2 sm:text-sm hover:bg-[#E2E3D8]/10 hover:border-[#B0D18B]/30 transition-all cursor-pointer text-xs font-medium text-[#E2E3D8] font-geist bg-[#E2E3D8]/5 border-[#8E9285]/20 border rounded-full pt-1.5 pr-3 pb-1.5 pl-3 gap-x-2 gap-y-2 items-center">WhatsApp<Image src="/drawables/whatsapp-2014-logo-brandlogos.net_1pgzl819j.svg" alt="WhatsApp Logo" width={16} height={16} className="lucide w-[16px] h-[16px]" style={{
        color: "rgb(226, 227, 216)"
      }} /></a>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <a href="https://t.me/mvplayer_EU" target="_blank" rel="noopener noreferrer" className="inline-flex gap-2 sm:px-4 sm:py-2 sm:text-sm hover:bg-[#E2E3D8]/10 hover:border-[#B0D18B]/30 transition-all cursor-pointer text-xs font-medium text-[#E2E3D8] font-geist bg-[#E2E3D8]/5 border-[#8E9285]/20 border rounded-full pt-1.5 pr-3 pb-1.5 pl-3 gap-x-2 gap-y-2 items-center">Telegram<Image src="/drawables/Telegram-OfAicCi46_brandlogos.net.svg" alt="Telegram Logo" width={16} height={16} className="lucide w-[16px] h-[16px]" style={{
        color: "rgb(226, 227, 216)"
      }} /></a>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <footer className="relative sm:fixed sm:bottom-0 w-full z-50 bg-[#0C0F09] border-[#8E9285]/20 border-t"><div className="sm:px-6 lg:px-8 sm:pt-12 sm:pb-12 max-w-7xl mr-auto ml-auto pt-8 pr-4 pb-8 pl-4"><div className="flex flex-col gap-6 sm:gap-8 sm:flex-row items-center justify-between">{t1}{t2}<div className="flex sm:gap-6 flex-wrap gap-x-4 gap-y-4 items-center justify-center">{t3}{t4}<Link href="/contact" className="inline-flex gap-2 sm:px-4 sm:py-2 sm:text-sm hover:bg-[#E2E3D8]/10 hover:border-[#B0D18B]/30 transition-all cursor-pointer text-xs font-medium text-[#E2E3D8] font-geist bg-[#E2E3D8]/5 border-[#8E9285]/20 border rounded-full pt-1.5 pr-3 pb-1.5 pl-3 gap-x-2 gap-y-2 items-center">Contact<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail" style={{
                color: "rgb(176, 209, 139)"
              }}><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" /><rect x="2" y="4" width="20" height="16" rx="2" /></svg></Link></div></div></div></footer>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}